import React, { useEffect, useState } from "react";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { login } from "../redux/features/authSlice";
import { loginValidation } from "./../utils/validation";
import { isYupError, parseYupError } from "./../utils/Yup";
import { toast } from "react-toastify";
import Loader from "../components/loaders/Loader";
import Cookies from "js-cookie";
const Login = () => {
  const dispatch = useDispatch();
  const [eye, setEye] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [form, setForm] = useState({
    email: "",
    password: "",
    userType: "admin"
  });

  const [formError, setFormError] = useState({});
  const navigate = useNavigate();
  const handleLogin = async (e) => {
    e.preventDefault();
    if (isLoading) return;
    try {
      setFormError({});
      setIsLoading(true);
      await loginValidation.validate(form, { abortEarly: false });
      await dispatch(login({ form, navigate, toast }));
    } catch (error) {
      if (isYupError(error)) {
        setFormError(parseYupError(error));
      } else {
        console.log(error);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value
    });
    setFormError({
      ...formError,
      [name]: ""
    });
  };

  useEffect(() => {
    const accessToken = Cookies.get(
      `${process.env.REACT_APP_NETWORK}accessToken`
    );

    if (accessToken) {
      navigate("/dashboard", { replace: true });
    }
  }, [navigate]);
  return (
    <div className=" min-h-screen scroll-none">
      <div className="border-b-2 relative z-50  ">
        <nav className="container ">
          <img src="/logo1.png" alt="saurabh" className="w-[5%] ml-20 py-2 " />
        </nav>
      </div>
      <div className="  my-auto justify-items-center absolute top-0 bottom-0 w-full flex justify-center bg-opacity-50  items-center  ">
        <img
          src="/images/LandingPage.jpg"
          alt=""
          className="inset-0 absolute"
        />
        <div className="shadow-[rgba(7,_65,_210,_0.1)_0px_9px_30px]  relative z-50   p-14 flex  flex-col items- rounded-2xl max-w-[550px] w-full m-center bg-[#D3B25B36] ">
          <h2 className=" text-[#242424] text-start font-poppins  text-[32px] leading-[100%]">
            Login as Admin{" "}
          </h2>
          <span className="text-[16px] mt-5 font-normal leading-[100%] text-[#2D2D2D]  font-poppins">
            Log in to manage Ventursa
          </span>

          <form
            className="w-full flex flex-col gap-6 mt-8"
            onSubmit={handleLogin}
          >
            <div className="space-y-2">
              <label
                htmlFor=""
                className="font-poppins  font-normal text-16 leading-[100%] "
              >
                Your email address
              </label>
              <input
                type="text"
                placeholder="Email Address"
                name="email"
                value={form.email}
                onChange={handleChange}
                className="bg-transparent border border-black"
              />
              {formError.email && (
                <div className="form-eror">{formError.email}</div>
              )}
            </div>
            <div>
              <div className="input_field relative space-y-2">
                <label
                  htmlFor=""
                  className="font-poppins  font-normal text-16 leading-[100%]"
                >
                  Password
                </label>
                <input
                  type={eye ? "text" : "password"}
                  placeholder="Password"
                  name="password"
                  onChange={handleChange}
                  className="bg-transparent border border-black"
                />

                <button
                  type="button"
                  className="absolute right-4 top-[60%] translate-y-[-50%] cursor-pointer z-10"
                  onClick={() => setEye(!eye)}
                >
                  {eye ? (
                    <AiFillEye className="text-2xl text-[#1C1B1F]" />
                  ) : (
                    <AiFillEyeInvisible className="text-2xl text-[#1C1B1F]" />
                  )}
                </button>
              </div>
              {formError.password && (
                <div className="form-eror">{formError.password}</div>
              )}
            </div>
            <button
              type="submit"
              className=" py-4 rounded-lg font-poppins  text-white w-full max-w-[100%] uppercase font-semibold btn-primary text-[16px] mt-8 "
            >
              {isLoading ? <Loader /> : "LogIn"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
